export default __webpack_public_path__ + "static/media/AUC.5015132e.svg";